import React, { useEffect } from 'react';
import { useGuestSessionMonitor } from '../hooks/useGuestSessionMonitor';
import { useAuth } from '../context/AuthContext';

interface GuestSessionManagerProps {
  children: React.ReactNode;
}

const GuestSessionManager: React.FC<GuestSessionManagerProps> = ({ children }) => {
  const { guestSession } = useAuth();
  useGuestSessionMonitor();

  // Only activate monitoring for verified guest sessions
  useEffect(() => {
    if (guestSession?.verified) {
      console.log('Guest session monitoring activated');
    }
  }, [guestSession]);

  return <>{children}</>;
};

export default GuestSessionManager;